<div class="container" style="max-width: 1140px;">
  <div class="row">
    <div class="col-auto pl-1 m-0" *ngIf="!isValid">
      <div style="width: 5px; height: 90%;" class="eca-invalid-bg"></div>
    </div>
    <div class="col m-0 p-0">
      <div class="form-group">
        <div class="flex-fill">
          <label for="ctrlNoteAsHtml"><strong>{{label}}</strong></label>
          <ng-template #popTemplate>
            <div *ngIf="!!popoverText" [ngClass]="isRequired ? 'required-input-guide' : 'optional-input-guide'"
                 [innerHtml]="popoverText"></div>
          </ng-template>
          <app-eca-input-guide class="float-right"
                               style="margin-top: 40px;"
                               *ngIf="popoverText"
                               [popoverText]="popoverText"
                               [isRequired]="isRequired"
                               [isDisabled]="isReadOnly">
          </app-eca-input-guide>
        </div>
        <div *ngIf="!isValid && validationMessage" class="eca-invalid"><strong>{{validationMessage}}</strong></div>

        <quill-editor [placeholder]="placeHolder" id="ctrlNoteAsHtml" *ngIf="!isReadOnly"
                      [modules]="editorOptions"
                      [ngClass]="isValid ? '': 'eca-invalid-input'"
                      [(ngModel)]="content" (ngModelChange)="onContentChanged()">
        </quill-editor>
        <quill-view *ngIf="isReadOnly" [content]="content" format="html" theme="snow">
        </quill-view>

      </div>
    </div>
  </div>
</div>
